import { useState } from "react";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { copyText } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PrimaryButton, SecondaryButton } from "@/components/shared/ui";

/** [Save for later]. Everything is saved as you go; this shows how to come back. */
export const SaveLater = ({ url }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" size="sm" className="-mr-2.5 text-muted-foreground" onClick={() => setOpen(true)} data-testid="save-later-button">
        <Bookmark /> Save for later
      </Button>
      {open && (
        <div className="fixed inset-0 z-30 flex items-end justify-center bg-black/40 md:items-center md:p-6" onClick={() => setOpen(false)} data-testid="save-later-sheet">
          <div className="rise w-full max-w-md rounded-t-3xl border bg-background p-6 pb-8 md:rounded-3xl md:pb-6" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-lg font-semibold">Your progress is saved</h2>
            <p className="mt-1 text-sm leading-relaxed text-muted-foreground">Every answer and upload is saved as you go. Open this private link any time to carry on where you left off.</p>
            <p className="mt-4 break-all rounded-xl bg-panel p-3 font-mono text-xs" data-testid="save-later-url">{url}</p>
            <div className="mt-5 flex flex-col gap-2">
              <PrimaryButton size="lg" onClick={async () => ((await copyText(url)) ? toast.success("Link copied") : toast.error("Couldn't copy"))} testid="save-later-copy">Copy my link</PrimaryButton>
              <SecondaryButton size="lg" onClick={() => setOpen(false)} testid="save-later-close">Keep going</SecondaryButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
